import { IAppState } from '../../redux';
import { TSpeciality } from '../../redux/reducers';

export const selectSpecialties = (state: IAppState): TSpeciality[] => state.offer.specialty?.specialties || [];
